/** Browser calls keep their native cookie behavior. Only SSR imports Node request state. */
export const consoleFetch: typeof globalThis.fetch = async (input, init) => {
  if (import.meta.env.SSR) {
    const { consoleRequestFetch } = await import("../server/request-context");
    return consoleRequestFetch(input, init);
  }
  return globalThis.fetch(input, init);
};
